/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { WebApiBatchJobDtoFailedItemDto } from './WebApiBatchJobDtoFailedItemDto';
import {
    WebApiBatchJobDtoFailedItemDtoFromJSON,
    WebApiBatchJobDtoFailedItemDtoFromJSONTyped,
    WebApiBatchJobDtoFailedItemDtoToJSON,
} from './WebApiBatchJobDtoFailedItemDto';
import type { WebApiModelsEnumerationTypesBatchStatus } from './WebApiModelsEnumerationTypesBatchStatus';
import {
    WebApiModelsEnumerationTypesBatchStatusFromJSON,
    WebApiModelsEnumerationTypesBatchStatusFromJSONTyped,
    WebApiModelsEnumerationTypesBatchStatusToJSON,
} from './WebApiModelsEnumerationTypesBatchStatus';
import type { WebApiModelsEnumerationTypesJobType } from './WebApiModelsEnumerationTypesJobType';
import {
    WebApiModelsEnumerationTypesJobTypeFromJSON,
    WebApiModelsEnumerationTypesJobTypeFromJSONTyped,
    WebApiModelsEnumerationTypesJobTypeToJSON,
} from './WebApiModelsEnumerationTypesJobType';

/**
 * DTO for batch job status with progress information
 * @export
 * @interface WebApiBatchJobDtoBatchJobStatusDto
 */
export interface WebApiBatchJobDtoBatchJobStatusDto {
    /**
     * Gets or sets the batch job identifier.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    id?: number;
    /**
     * Gets or sets the request identifier for correlation.
     * @type {string}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    requestId?: string;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesBatchStatus}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    status?: WebApiModelsEnumerationTypesBatchStatus;
    /**
     * 
     * @type {WebApiModelsEnumerationTypesJobType}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    jobType?: WebApiModelsEnumerationTypesJobType;
    /**
     * Gets or sets the total number of items in the batch.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    totalItems?: number;
    /**
     * Gets or sets the number of completed items.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    completedItems?: number;
    /**
     * Gets or sets the number of failed items.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    failedItems?: number;
    /**
     * Gets or sets the number of pending items.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    pendingItems?: number;
    /**
     * Gets or sets the completion percentage (0-100).
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    percentComplete?: number;
    /**
     * Gets or sets when the batch job was created.
     * @type {Date}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    createdAt?: Date;
    /**
     * Gets or sets when the batch job started processing.
     * @type {Date}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    startedAt?: Date | null;
    /**
     * Gets or sets when the batch job completed.
     * @type {Date}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    completedAt?: Date | null;
    /**
     * Gets or sets the error message if the job failed.
     * @type {string}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    errorMessage?: string | null;
    /**
     * Gets or sets the estimated completion time (calculated based on current progress).
     * @type {Date}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    estimatedCompletion?: Date | null;
    /**
     * Gets or sets the company identifier.
     * @type {number}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    companyId?: number;
    /**
     * Gets or sets the list of failed items with error details.
     * @type {Array<WebApiBatchJobDtoFailedItemDto>}
     * @memberof WebApiBatchJobDtoBatchJobStatusDto
     */
    failedItemDetails?: Array<WebApiBatchJobDtoFailedItemDto> | null;
}

/**
 * Check if a given object implements the WebApiBatchJobDtoBatchJobStatusDto interface.
 */
export function instanceOfWebApiBatchJobDtoBatchJobStatusDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebApiBatchJobDtoBatchJobStatusDtoFromJSON(json: any): WebApiBatchJobDtoBatchJobStatusDto {
    return WebApiBatchJobDtoBatchJobStatusDtoFromJSONTyped(json, false);
}

export function WebApiBatchJobDtoBatchJobStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebApiBatchJobDtoBatchJobStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'status': !exists(json, 'status') ? undefined : WebApiModelsEnumerationTypesBatchStatusFromJSON(json['status']),
        'jobType': !exists(json, 'jobType') ? undefined : WebApiModelsEnumerationTypesJobTypeFromJSON(json['jobType']),
        'totalItems': !exists(json, 'totalItems') ? undefined : json['totalItems'],
        'completedItems': !exists(json, 'completedItems') ? undefined : json['completedItems'],
        'failedItems': !exists(json, 'failedItems') ? undefined : json['failedItems'],
        'pendingItems': !exists(json, 'pendingItems') ? undefined : json['pendingItems'],
        'percentComplete': !exists(json, 'percentComplete') ? undefined : json['percentComplete'],
        'createdAt': !exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'startedAt': !exists(json, 'startedAt') ? undefined : (json['startedAt'] === null ? null : new Date(json['startedAt'])),
        'completedAt': !exists(json, 'completedAt') ? undefined : (json['completedAt'] === null ? null : new Date(json['completedAt'])),
        'errorMessage': !exists(json, 'errorMessage') ? undefined : json['errorMessage'],
        'estimatedCompletion': !exists(json, 'estimatedCompletion') ? undefined : (json['estimatedCompletion'] === null ? null : new Date(json['estimatedCompletion'])),
        'companyId': !exists(json, 'companyId') ? undefined : json['companyId'],
        'failedItemDetails': !exists(json, 'failedItemDetails') ? undefined : (json['failedItemDetails'] === null ? null : (json['failedItemDetails'] as Array<any>).map(WebApiBatchJobDtoFailedItemDtoFromJSON)),
    };
}

export function WebApiBatchJobDtoBatchJobStatusDtoToJSON(value?: WebApiBatchJobDtoBatchJobStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'requestId': value.requestId,
        'status': WebApiModelsEnumerationTypesBatchStatusToJSON(value.status),
        'jobType': WebApiModelsEnumerationTypesJobTypeToJSON(value.jobType),
        'totalItems': value.totalItems,
        'completedItems': value.completedItems,
        'failedItems': value.failedItems,
        'pendingItems': value.pendingItems,
        'percentComplete': value.percentComplete,
        'createdAt': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'startedAt': value.startedAt === undefined ? undefined : (value.startedAt === null ? null : value.startedAt.toISOString()),
        'completedAt': value.completedAt === undefined ? undefined : (value.completedAt === null ? null : value.completedAt.toISOString()),
        'errorMessage': value.errorMessage,
        'estimatedCompletion': value.estimatedCompletion === undefined ? undefined : (value.estimatedCompletion === null ? null : value.estimatedCompletion.toISOString()),
        'companyId': value.companyId,
        'failedItemDetails': value.failedItemDetails === undefined ? undefined : (value.failedItemDetails === null ? null : (value.failedItemDetails as Array<any>).map(WebApiBatchJobDtoFailedItemDtoToJSON)),
    };
}

